import ListicleHero from '@/component/BBFC/ListicleHero/ListicleHero'
import React from 'react'

const ListicleHeroWidget = (props) => {
  return <ListicleHero {...props} />
}

export default ListicleHeroWidget
